<template>
  <div :class="cssClass">
    <pvd-system-message
      :id="`${idPrefix}Error`"
      :message="message"
      :placement="placement"
      :type="type"
    />
  </div>
</template>

<script>
export default {
  name: 'InlineMessage',
  props: {
    message: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'inline',
    },
    type: {
      type: String,
      default: 'alert',
    },
    idPrefix: {
      type: String,
      default: '',
    },
    cssClass: {
      type: String,
      default: 'form-row-message',
    },
  },
};
</script>

<style scoped>

</style>
